<template>
  <vs-navbar>
    <div slot="title">
      <vs-navbar-title>
        <span class="company-name">QuickSend</span>
      </vs-navbar-title>
    </div>

    <vs-navbar-item index="0">
      <router-link to="/logout">Logout</router-link>
    </vs-navbar-item>
  </vs-navbar>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'

export default {
  components: {
    Logo
  }
}
</script>

<style>
.vs-navbar{
  height: 75px;
}

.vs-navbar--item a{
  font-size: 1rem;
}

.company-name{
    font-size: 1.5rem;
    align-items: center;
    color: #F9278E;
}

a:hover {
    color:#F9278E ;
}

@media screen and (max-width: 900px) {
  .vs-navbar{
  height: 50%;
  width: 400px;
  }

}
</style>
